import { fetchNodesTimeseriesAggregatedDataForDashboard } from "../api/timeseries/fetch-nodes-timeseries-aggregated-data-for-dashboard";
import { fetchNodesTimeseriesAggregatedDataForDashboardWithLastAvailableTimestamp } from "../api/timeseries/fetch-nodes-timeseries-aggregated-data-with-last-available-timestamp";

export const getTimeseriesAggregatedDataForDashboard = async (
  groupId,
  tile,
  lookForLastAvailableTimeStampBeforeFetchingData = false,
  signal?: AbortSignal,
) => {
  if (lookForLastAvailableTimeStampBeforeFetchingData) {
    return await fetchNodesTimeseriesAggregatedDataForDashboardWithLastAvailableTimestamp(
      groupId,
      tile.getFrequency(),
      tile.getTimePeriod(),
      tile.getNodes(),
      signal,
    );
  } else {
    return await fetchNodesTimeseriesAggregatedDataForDashboard(
      groupId,
      tile.getFrequency(),
      tile.getTimePeriod(),
      tile.getNodes(),
      signal,
    );
  }
};
